<template>
    <div ref="div" class="table" @keydown="keydown">
        <v-table v-show="show" fixed-header :height="divHeight > 0 ? divHeight : 'auto'" class="working-area overflow-x-auto"
            :class="loading ? 'blur': ''" ref="table" style="" tabindex="0">
            <thead ref="header">
                <tr>
                    <th v-for="(item, index) in headers" :key="index" class="data-header" v-ripple
                        @click="controller?.sortable(index) ? sort(index) : undefined"
                        :style="controller.fixed(index) ? 'width:' + controller.fixed(index) + ';' : ''">
                        <div class="d-flex" style="align-items: center;">
                            <v-menu :close-on-content-click="false" v-if="controller.columnFilter(index) != undefined">
                                <template v-slot:activator="{ props }">
                                    <v-btn variant="text" :color="controller.columnFilter(index).marked ? 'primary' : 'default'"
                                        :icon="controller.columnFilter(index).marked ? 'mdi-filter' : 'mdi-filter-menu-outline'"
                                        v-bind="props"></v-btn>
                                </template>
                                <template v-slot:default="{ isActive }">
                                    <component :is="controller.columnFilter(index).component" v-bind="isActive"
                                        :filter="controller.columnFilter(index).filter" :title="item" :isActive="isActive"
                                        @submit="isActive.value = false;controller.submitFilter();"></component>
                                </template>
                            </v-menu>
                            <div class="data-header-row">
                                {{ item }}
                            </div>
                            <v-icon v-if="column == index && controller?.sortable(index)" class="ma-1 sort-icon"
                                :icon="'mdi-' + (order == 1 ? 'sort-ascending' : 'sort-descending')">
                            </v-icon>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody class="overflow-y-auto">
                <tr :style="'height:' + topHeight + 'px;'"></tr>
                <tr v-if="length > 0" ref="first" :class="row_cls(first)" :style="controller.decorator(first)"
                    @click="(e) => select_row(e, first)">
                    <td v-for="(_, column) in headers" :key="column">
                        <div class="tdiv">
                            <component :is="get_component(first, column)" :value="controller.value(first, column)" />
                        </div>
                    </td>
                </tr>
                <tr v-for="row in splice" :key="controller.id(row + first)" :class="row_cls(row + first)"
                    :style="controller.decorator(row + first)" @click="(e) => select_row(e, row + first)">
                    <td v-for="(_, column) in headers" :key="controller.id(row + first) + '@' + column">
                        <div class="tdiv">
                            <component :is="get_component(row + first, column)" :value="controller.value(row + first, column)" />
                        </div>
                    </td>
                </tr>
                <tr :style="'height:' + bottomHeight + 'px;'"></tr>
            </tbody>
        </v-table>
        <div v-if="loading" class="progress-ground">
            <v-progress-circular class="spinner" color="primary" indeterminate :size="128" :width="6">
                {{ typeof loading === "string" ? loading : $tr('Загрузка...') }}
            </v-progress-circular>
        </div>
        <v-snackbar v-model="snackbar_error" :timeout="10000">
            {{ error }}
            <template v-slot:actions>
                <v-btn color="red" variant="text" @click="snackbar_error = false">
                    {{ $tr("Закрыть") }}
                </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="snackbar_message" :timeout="10000">
            {{ message }}
            <template v-slot:actions>
                <v-btn color="green" variant="text" @click="snackbar_message = false">
                    {{ $tr("Закрыть") }}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { reactive, markRaw } from 'vue';
import TableSimpleValue from './TableSimpleValue.vue';
import EnumFilter from './EnumFilter.vue';

export class TableViewController {
    headers() {
        return [];
    }

    length() {
        return 0;
    }

    id(row) {
        return `${row}`;
    }

    component(/* row, column */) {
        return TableSimpleValue;
    }

    value(/* row, column */) {
        return null;
    }

    sort(/* column, order */) {

    }

    sortable(/* column */) {
        return false;
    }

    selectable(/* row */) {
        return true;
    }

    fixed(/* column */) {
        return undefined;
    }

    decorator(/* row */) {
        return undefined;
    }

    columnFilter(/* column */) {
        return undefined;
    }

    submitFilter() {

    }

    //

    fullTextSearchValue(value) {
        return value;
    }

    fullTextSearch(table, query) {
        const p = (query || '').trim().toLowerCase().split('+').filter((val) => val !== '');
        if (p.length > 0) {
            const conds = [];
            for (let i = 0; i < p.length; i += 1) {
                const quotes = p[i].split('"');
                let idx = 0;
                const cond = [];
                while (idx < quotes.length) {
                    if (idx % 2 === 0) {
                        const s = (quotes[idx] || '').trim().split(' ').filter((val) => val !== '');
                        for (let k = 0; k < s.length; k += 1) {
                            const c = s[k].trim().split(' ').filter((val) => val !== '');
                            for (let j = 0; j < c.length; j += 1) {
                                cond.push(c[j]);
                            }
                        }
                    } else if (quotes[idx] !== '') {
                        cond.push(quotes[idx]);
                    }
                    idx += 1;
                }
                if (cond.length > 0) {
                    conds.push(cond);
                }
            }
            return table.filter((val) => {
                const text = JSON.stringify(this.fullTextSearchValue(val)).toLowerCase().replaceAll('"', '');
                for (let i = 0; i < conds.length; i += 1) {
                    const cond = conds[i];
                    if (cond.length > 0) {
                        let matched = 0;
                        for (let j = 0; j < cond.length; j += 1) {
                            if (text.indexOf(cond[j]) >= 0) {
                                matched += 1;
                            }
                        }
                        if (matched === cond.length) {
                            return true;
                        }
                    }
                }
                return false;
            });
        }
        return table;
    }
}

export class TableSimpleController extends TableViewController {
    constructor(app, cache) {
        super();
        const table = markRaw(cache || []);
        this.app = app;
        this.cache = cache;
        this.data = reactive({
            table,
            loading: cache?.length === 0,
            headers: [],
            length: table.length,
        });
        this.filter = '';
    }

    initialize() {
        this.initializeFilters();
        this.fetch().then((table) => {
            this.cache = markRaw(table);
            this.initializeFilters();
            this.data.loading = false;
            this.searchTable();
        }).catch((e) => {
            this.data.loading = false;
            this.data.error = e;
        });
    }

    initializeFilters() {
        for (let i = 0; i < this.data.headers.length; i += 1) {
            const header = this.data.headers[i];
            if ((header.autofilter) && (this.cache != null)) {
                const values = {};
                for (let j = 0; j < this.cache.length; j += 1) {
                    const data = this.cache[j];
                    let key = this.valueAt(data, i);
                    if (key != null) {
                        if (key.value != null) {
                            key = key.value;
                        }
                        values[key] = key;
                    }
                }
                const keys = Object.keys(values);
                if (keys.length > 0) {
                    const settings = this.load_settings(`filter_${header.name}`) || {};
                    const selected = [];
                    for (let j = 0; j < keys.length; j += 1) {
                        if (settings[keys[j]] !== false) {
                            selected.push(keys[j]);
                        }
                    }
                    const header_binder = header.binder;
                    header.filter = {
                        filter: {
                            selected,
                            values: header_binder === undefined ? keys : header_binder(keys),
                        },
                        component: markRaw(EnumFilter),
                    };
                }
            }
        }
    }

    get error() {
        return this.data.error;
    }

    get message() {
        return this.data.message;
    }

    load_settings(key) {
        const id = this.cid;
        if (id == null) {
            return undefined;
        }
        let filters;
        try {
            filters = JSON.parse(localStorage.getItem('filter'));
            if (filters == null) {
                filters = {};
            }
        } catch {
            filters = {};
        }
        return (filters[id] || {})[key];
    }

    save_settings(key, value) {
        const id = this.cid;
        if (id == null) {
            return;
        }
        let filters;
        try {
            filters = JSON.parse(localStorage.getItem('filter'));
            if (filters == null) {
                filters = {};
            }
        } catch {
            filters = {};
        }
        const values = filters[id] || {};
        values[key] = value;
        filters[id] = values;
        localStorage.setItem('filter', JSON.stringify(filters));
    }

    add(title, name, type, fixed, binder = undefined) {
        const header = {
            title,
            name,
            type: markRaw(type || TableSimpleValue),
            fixed,
            binder,
        };
        this.data.headers.push(header);
        return header;
    }

    get loading() {
        return this.data.loading;
    }

    headers() {
        const headers = [];
        for (let i = 0; i < this.data.headers.length; i += 1) {
            headers.push(this.app.$tr(this.data.headers[i].title));
        }
        return headers;
    }

    fixed(column) {
        return this.data.headers[column].fixed;
    }

    length() {
        return this.data.length;
    }

    component(row, column) {
        return this.data.headers[column].type;
    }

    value(row, column) {
        const data = this.data.table[row];
        return this.valueAt(data, column);
    }

    valueAt(data, column) {
        const header = this.data.headers[column];
        return data[header.name];
    }

    search(query) {
        this.query = query;
        this.searchTable();
    }

    submitFilter() {
        this.searchTable();
    }

    filterTable(ptable) {
        let table = this.fullTextSearch(ptable, this.query);
        for (let i = 0; i < this.data.headers.length; i += 1) {
            const header = this.data.headers[i];
            if (header.autofilter) {
                const filter = header.filter?.filter;
                if (filter != null) {
                    if (filter.selected.length !== filter.values.length) {
                        const selected = {};
                        for (let j = 0; j < filter.values.length; j += 1) {
                            selected[filter.values[j]] = false;
                        }
                        for (let j = 0; j < filter.selected.length; j += 1) {
                            selected[filter.selected[j]] = true;
                        }
                        this.save_settings(`filter_${header.name}`, selected);
                        table = markRaw(table.filter((a) => {
                            const value = this.valueAt(a, i);
                            return selected[value?.value || value];
                        }));
                    } else {
                        this.save_settings(`filter_${header.name}`, undefined);
                    }
                }
            }
        }
        return table;
    }

    searchTable() {
        const table = this.filterTable(this.cache) || [];
        this.data.table = markRaw(table);
        this.data.length = this.data.table.length;
        if (table.length > 0) {
            if ((this.column != null) && (this.order != null)) {
                this.sort(this.column, this.order);
            } else {
                for (let i = 0; i < this.data.headers.length; i += 1) {
                    const header = this.data.headers[i];
                    if (header.order != null) {
                        this.sort(i, header.order);
                        break;
                    }
                }
            }
        }
    }

    sortable() {
        return true;
    }

    compare(pa, pb, column) {
        let a = this.valueAt(pa, column);
        let b = this.valueAt(pb, column);
        if (a?.value != null) {
            a = a.value;
        }
        if (b?.value != null) {
            b = b.value;
        }
        if (typeof a === 'number') {
            return (a < b) ? -1 : 1;
        } if (typeof a === 'string') {
            return (a || '').toLowerCase() < (b || '').toLowerCase() ? -1 : 1;
        }
        a = JSON.stringify(a || '').toLowerCase();
        b = JSON.stringify(b || '').toLowerCase();
        return a < b ? -1 : 1;
    }

    sort(column, order) {
        if ((column >= this.headers().length) || (column < 0)) {
            return;
        }
        this.order = order;
        this.column = column;
        if (this.data.loading) {
            return;
        }
        this.data.table = this.data.table.sort((a, b) => {
            const cmp = this.compare(a, b, column);
            return cmp < 0 ? -order : order;
        });
        this.data.length = this.data.table.length;
    }

    columnFilter(column) {
        const header = this.data.headers[column];
        const filter = header.filter;
        if ((filter != null) && (header.autofilter)) {
            filter.marked = filter.filter.selected.length !== filter.filter.values.length;
        }
        return filter;
    }

    fullTextSearchValue(value) {
        const result = [value];
        for (let i = 0; i < this.data.headers.length; i += 1) {
            const v = this.valueAt(value, i);
            if (v != null) {
                result.push(v);
            }
        }
        return result;
    }
}

export default {
    components: {
        TableSimpleValue,
    },
    name: 'TableView',
    props: {
        controller: {
            type: Object,
            default: new TableViewController(),
        },
        selection: null,
        multiselect: {
            type: Boolean,
            default: false,
        },
        blocks: {
            type: Number,
            default: 2,
        },
        sorter: {
            type: Object,
            default: reactive({
                column: undefined,
                order: 1,
            }),
        },
    },
    data() {
        return {
            cachedItemHeight: 0,
            cachedContainerHeight: 0,
            cachedDivHeight: 0,
            scroll: 0,
            scrollspy: false,
            snackbar_error: false,
            snackbar_message: false,
            msorter: this.sorter,
        };
    },
    mounted() {
        this.invoke_sort();
    },
    computed: {
        length() {
            return this.controller?.length() || 0;
        },
        visible() {
            return Math.ceil(this.containerHeight / this.itemHeight);
        },
        splice() {
            return Math.max(Math.min(this.visible * this.blocks - 1, this.length - 1 - this.first), 0);
        },
        chunk() {
            const height = this.itemHeight;
            const blocksize = Math.max(this.visible * (this.blocks - 1) * height, height);
            const scroll = this.scroll;
            return Math.floor(Math.max(scroll, 0) / blocksize);
        },
        first() {
            return Math.min(Math.max(this.chunk * this.visible * (this.blocks - 1), 0), this.length - 1);
        },
        itemHeight() {
            this.update();
            if (this.cachedItemHeight <= 0) {
                return 52;
            }
            return Math.round(this.cachedItemHeight);
        },
        containerHeight() {
            this.update();
            return Math.round(this.cachedContainerHeight);
        },
        divHeight() {
            this.update();
            return Math.round(this.cachedDivHeight);
        },
        fullHeight() {
            return this.itemHeight * this.length;
        },
        topHeight() {
            const height = this.itemHeight;
            const blocksize = this.visible * height;
            return Math.max(this.chunk * blocksize * (this.blocks - 1), 0);
        },
        bottomHeight() {
            const height = this.itemHeight;
            return Math.max((this.length - this.visible * this.blocks) * height - this.topHeight, 0);
        },
        scroller() {
            const table = this.$refs.table;
            if (table != null) {
                for (let i = 0; i < table.$el.childNodes.length; i += 1) {
                    const el = table.$el.childNodes[i];
                    if (el.className === 'v-table__wrapper') {
                        return el;
                    }
                }
            }
            return undefined;
        },
        show() {
            return this.length > 0 || !this.loading;
        },
        headers() {
            return this.controller?.headers();
        },
        column() {
            return this.sorter?.column;
        },
        order() {
            return this.sorter?.order || 1;
        },
        loading() {
            return this.controller?.loading;
        },
        error() {
            return this.controller?.error;
        },
        message() {
            return this.controller?.message;
        },
    },
    watch: {
        controller() {
            this.invoke_sort();
            this.$nextTick(() => {
                this.update();
                this.onscroll();
            });
        },
        column() {
            this.invoke_sort();
        },
        order() {
            this.invoke_sort();
        },
        error(value) {
            this.snackbar_error = value != null;
        },
        message(value) {
            this.snackbar_message = value != null;
        },
    },
    methods: {
        row_cls(row) {
            const selection = this.selection;
            if (!this.controller.selectable(row)) {
                return '';
            }
            if (selection != null) {
                if (selection.selected[row]) {
                    if (selection.active === row) {
                        return 'data-row selected active';
                    }
                    return 'data-row selected';
                }
            }
            return 'data-row';
        },
        sort(column) {
            if (this.controller.sortable(column)) {
                if (this.sorter != null) {
                    if (this.msorter.column === column) {
                        this.msorter.order = -this.order || 1;
                    } else {
                        this.msorter.column = column;
                        this.msorter.order = 1;
                    }
                }
            }
        },
        invoke_sort() {
            const controller = this.controller;
            if ((controller != null) && (this.column != null)) {
                if (this.controller.sortable(this.column)) {
                    controller.sort(this.column, this.order);
                }
            }
        },
        select_row(e, row) {
            const selection = this.selection;
            if (selection == null) {
                return;
            }
            if (!this.controller?.selectable(row)) {
                return;
            }
            let shift = e.shiftKey;
            let ctrl = e.ctrlKey || e.metaKey;
            if (!this.multiselect) {
                shift = false;
                ctrl = false;
            }
            if (window.getSelection) {
                if (window.getSelection().empty) { // Chrome
                    window.getSelection().empty();
                } else if (window.getSelection().removeAllRanges) { // Firefox
                    window.getSelection().removeAllRanges();
                }
            } else if (document.selection) { // IE?
                document.selection.empty();
            }
            if (ctrl) {
                if (selection.selected[row] == null) {
                    selection.selected[row] = true;
                    selection.active = row;
                } else {
                    delete selection.selected[row];
                    if (selection.active === row) {
                        selection.active = null;
                    }
                }
            } else if (shift) {
                if (selection.active != null) {
                    const from = Math.min(selection.active, row);
                    const to = Math.max(selection.active, row);
                    for (let i = from; i <= to; i += 1) {
                        selection.selected[i] = true;
                    }
                    selection.active = row;
                } else {
                    selection.selected[row] = true;
                    selection.active = row;
                }
            } else if (selection.selected[row] == null) {
                selection.selected = {};
                selection.selected[row] = true;
                selection.active = row;
            } else {
                selection.selected = {};
                selection.active = null;
            }
        },
        keydown(e) {
            const selection = this.selection;
            if (selection == null) {
                return;
            }
            let direction;
            if (e.keyCode === 40) {
                direction = 1;
                e.preventDefault();
            } else if (e.keyCode === 38) {
                direction = -1;
                e.preventDefault();
            } else {
                return;
            }
            let shift = e.shiftKey;
            if (!this.multiselect) {
                shift = false;
            }
            if (window.getSelection) {
                if (window.getSelection().empty) { // Chrome
                    window.getSelection().empty();
                } else if (window.getSelection().removeAllRanges) { // Firefox
                    window.getSelection().removeAllRanges();
                }
            } else if (document.selection) { // IE?
                document.selection.empty();
            }
            let active = selection.active;
            if (active == null) {
                if (direction < 0) {
                    active = this.length;
                } else {
                    active = -1;
                }
            }
            for (;;) {
                active += direction;
                if (active >= 0 && active < this.length) {
                    if (this.controller?.selectable(active)) {
                        if (shift) {
                            if (selection.active != null) {
                                const from = Math.min(selection.active, active);
                                const to = Math.max(selection.active, active);
                                for (let i = from; i <= to; i += 1) {
                                    selection.selected[i] = true;
                                }
                                selection.active = active;
                            } else {
                                selection.selected[active] = true;
                                selection.active = active;
                            }
                        } else {
                            selection.selected = {};
                            selection.selected[active] = true;
                            selection.active = active;
                        }
                        if (selection.active != null) {
                            const scroller = this.scroller;
                            if (scroller != null) {
                                if (this.itemHeight * selection.active - this.scroll < 0) {
                                    scroller.scrollTop = this.itemHeight * selection.active;
                                } else if (this.itemHeight * selection.active - this.scroll > this.containerHeight) {
                                    scroller.scrollTop = this.itemHeight * selection.active - this.containerHeight / 5;
                                }
                            }
                        }
                        break;
                    }
                } else {
                    break;
                }
            }
        },
        update() {
            if (this.show) {
                const first = this.$refs.first;
                if (first != null) {
                    this.cachedItemHeight = first.clientHeight;
                } else {
                    this.$nextTick(() => {
                        const item = this.$refs.first;
                        if (item != null) {
                            this.cachedItemHeight = item.clientHeight;
                        }
                    });
                }
                const table = this.$refs.table;
                const header = this.$refs.header;
                if ((table != null) && (header != null)) {
                    this.cachedContainerHeight = Math.max(
                        table.$el.clientHeight - header.clientHeight,
                        this.cachedContainerHeight,
                    );
                    if (!this.scrollspy) {
                        const scroller = this.scroller;
                        if (scroller != null) {
                            scroller.onscroll = this.onscroll;
                            this.scrollspy = true;
                        }
                    }
                } else {
                    this.$nextTick(() => {
                        const el = this.$refs.table;
                        const hdr = this.$refs.header;
                        if ((el != null) && (hdr != null)) {
                            this.cachedContainerHeight = Math.max(
                                el.$el.clientHeight - hdr.clientHeight,
                                this.cachedContainerHeight,
                            );
                        }
                    });
                }
                const top = this.$refs.div;
                if (top != null) {
                    this.cachedDivHeight = top.clientHeight;
                } else {
                    this.$nextTick(() => {
                        const item = this.$refs.div;
                        if (item != null) {
                            this.cachedDivHeight = item.clientHeight;
                        }
                    });
                }
            }
        },
        onscroll() {
            const scroller = this.scroller;
            if (scroller != null) {
                this.scroll = Math.round(scroller.scrollTop);
            }
        },
        get_component(row, column) {
            return this.controller?.component(row, column);
        },
    },
};
</script>

<style scoped>
.data-header {
    cursor: pointer;
}

.data-header:hover {
    color: rgb(var(--v-theme-primary));
}

.data-header-row {
    justify-content: space-between !important;
    display: flex !important;
    align-items: center;
    text-transform: uppercase;
}

.data-row {
    cursor: pointer;
    height: 52px !important;
}

.data-row.selected {
    background-color: rgba(var(--v-theme-primary), calc(0.12 * var(--v-theme-overlay-multiplier))) !important;
}

.data-row.selected.active {
    background-color: rgba(var(--v-theme-primary), calc(0.36 * var(--v-theme-overlay-multiplier))) !important;
}

.data-row:hover {
    background: rgba(var(--v-theme-primary), calc(0.24 * var(--v-theme-overlay-multiplier))) !important;
}

.tdiv {
    max-height: 52px;
    overflow: hidden;
    text-overflow: ellipsis;
}

tbody>tr>td {
    border: 0 !important;
}

.sort-icon:before,
.mdi-set {
    font-size: 16px !important;
}

.table {
    display: grid;
    height: 100%;
    background: rgb(var(--v-theme-surface));
}

.working-area {
    grid-area: 1 / 1;
}

.progress-ground {
    width: 100%;
    height: 100%;
    display: flex !important;
    grid-area: 1 / 1;
}

.spinner {
    width: 10rem;
    height: 10rem;
    margin: auto auto;
    align-self: center;
}

.blur {
    filter: blur(4px);
    pointer-events: none;
}
</style>
